import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { AppsReleasesListenerEffect } from '../effects/apps-releases-listener.effect';
import { releasesActions } from '../store/slices/releases.slice';

export const appsReleasesListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeAppsFilterListener: UnsubscribeListener =
  appsReleasesListener.startListening({
    matcher: isAnyOf(
      releasesActions.setAppId,
      releasesActions.addPagination,
      releasesActions.resetPagination
    ),
    effect: AppsReleasesListenerEffect,
  });
